import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "sticky flex items-center left-0 uppercase" }
const _hoisted_2 = ["src"]

import { IonIcon } from '@ionic/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeTableItemTitle',
  props: {
	iconUrl: { type: String },
	imageUrl: { type: String },
	rowStart: { type: Number, required: true },
	title: { type: String, required: true },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex col-start-1 font-sourcesanspro-semibold text-sm relative",
    style: _normalizeStyle(`grid-column-end: -1; grid-row-start: ${props.rowStart};`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.iconUrl || __props.imageUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "max-w-[1rem] max-h-[1rem] mr-1 -rotate-90 invert",
            src: __props.iconUrl || __props.imageUrl
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(props.title), 1)
    ])
  ], 4))
}
}

})